import React, { useState } from 'react';

interface LoginPageProps {
  onLogin: () => void;
}

export default function LoginPage({ onLogin }: LoginPageProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simple password check for admin panel
    if (password === 'mds2026!') {
      onLogin();
    } else {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#0B0E14',
    }}>
      <div style={{
        width: '380px',
        padding: '40px',
        backgroundColor: '#151921',
        border: '1px solid #1E2330',
        borderRadius: '16px',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '2rem', marginBottom: '8px', color: '#00D97E' }}>
            <i className="fa-solid fa-chart-pie"></i>
          </div>
          <h1 style={{ fontSize: '1.3rem', fontWeight: 800, margin: '0 0 4px' }}>
            <span style={{ color: '#00D97E' }}>MDS</span> Admin
          </h1>
          <p style={{ color: '#4A5068', fontSize: '0.75rem' }}>Market Data Service</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '0.7rem', fontWeight: 600, color: '#7B8399', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Passwort
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              autoFocus
              style={{
                width: '100%',
                padding: '12px 16px',
                backgroundColor: '#1E2330',
                border: `1px solid ${error ? '#FF4757' : '#2A3040'}`,
                borderRadius: '8px',
                color: '#E8EAED',
                fontSize: '0.9rem',
                outline: 'none',
                transition: 'border-color 0.2s',
              }}
              onFocus={e => { if (!error) e.target.style.borderColor = '#00D97E'; }}
              onBlur={e => { if (!error) e.target.style.borderColor = '#2A3040'; }}
            />
            {error && (
              <p style={{ color: '#FF4757', fontSize: '0.7rem', marginTop: '6px' }}>Falsches Passwort</p>
            )}
          </div>

          <button
            type="submit"
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#00D97E',
              color: '#0B0E14',
              border: 'none',
              borderRadius: '8px',
              fontSize: '0.85rem',
              fontWeight: 700,
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={e => (e.target as HTMLButtonElement).style.backgroundColor = '#00C470'}
            onMouseLeave={e => (e.target as HTMLButtonElement).style.backgroundColor = '#00D97E'}
          >
            Anmelden
          </button>
        </form>
      </div>
    </div>
  );
}
